module.exports = __webpack_public_path__ + "static/img/ostaliprihodiirashodi1.feb0d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/ostaliprihodiirashodi1.png
// module id = Jsow
// module chunks = 0